"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingPeriod = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../shared/core");
var analytics_subjects_1 = require("../analytics-subjects");
var copy_1 = require("../copy");
var date_1 = require("../utils/date");
var money_1 = require("../utils/money");
var BillingTable_1 = require("./BillingTable");
var Context_1 = require("./Context");
var RowTitle = function (_a) {
    var label = _a.label, date = _a.date;
    return (react_1.default.createElement(BillingTable_1.StyledBillingHistoryCell, null,
        label,
        " ",
        react_1.default.createElement(Context_1.Context, { contexts: [date] })));
};
var BalanceLabel = function (_a) {
    var label = _a.label, date = _a.date;
    var Strong = (0, core_1.useComponents)().Strong;
    return (react_1.default.createElement(BillingTable_1.StyledBillingHistoryCell, null,
        react_1.default.createElement(Strong, null, label),
        " ",
        react_1.default.createElement(Context_1.Context, { contexts: [date] })));
};
var RowValue = function (_a) {
    var amount = _a.amount, isClosingBalance = _a.isClosingBalance, creditType = _a.creditType;
    var formattedAmount = (0, core_1.absoluteMajor2DP)((0, core_1.majorToMinor)(amount));
    var suffix = (0, money_1.useCorrectSuffix)(creditType, amount);
    var Strong = (0, core_1.useComponents)().Strong;
    return (react_1.default.createElement(BillingTable_1.StyledBillingHistoryCell, null,
        isClosingBalance ? react_1.default.createElement(Strong, null, formattedAmount) : formattedAmount,
        ' ',
        react_1.default.createElement(Context_1.Context, { contexts: [suffix] })));
};
RowValue.defaultProps = {
    isClosingBalance: false,
};
var BillingPeriod = function (_a) {
    var _b;
    var id = _a.id, start = _a.start, end = _a.end, startingBalance = _a.startingBalance, closingBalance = _a.closingBalance, totalCharges = _a.totalCharges, payments = _a.payments, _c = _a.isCurrentBillingPeriod, isCurrentBillingPeriod = _c === void 0 ? false : _c, _d = _a.hideTableHeading, hideTableHeading = _d === void 0 ? false : _d, _e = _a.titlePrepend, titlePrepend = _e === void 0 ? '' : _e;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var _f = (0, core_1.useComponents)(), TableRow = _f.TableRow, TableBody = _f.TableBody, DataTable = _f.DataTable;
    var rows = [];
    var Heading4 = (0, core_1.useComponents)().Heading4;
    if (startingBalance) {
        rows.push([
            react_1.default.createElement(RowTitle, { key: "".concat(id, "-start-title"), label: copy('startingBalanceLabel'), date: (0, date_1.formatRowDate)(start) }),
            react_1.default.createElement(RowValue, { key: "".concat(id, "-start-value"), amount: startingBalance, creditType: "balance" }),
        ]);
    }
    if (totalCharges) {
        rows.push([
            react_1.default.createElement(RowTitle, { key: "".concat(id, "-total-title"), label: copy('totalChargesLabel') }),
            react_1.default.createElement(RowValue, { key: "".concat(id, "-total-value"), amount: totalCharges, creditType: "charge" }),
        ]);
    }
    if (payments && payments.length > 0) {
        payments.map(function (payment, index) {
            return rows.push([
                react_1.default.createElement(RowTitle, { key: "".concat(id, "-date-").concat(index), label: payment.description, date: payment.date ? (0, date_1.formatRowDate)(payment.date) : undefined }),
                react_1.default.createElement(RowValue, { key: "".concat(id, "-value-").concat(index), amount: payment.credit.pounds, creditType: "payment" }),
            ]);
        });
    }
    if (closingBalance) {
        rows.push([
            react_1.default.createElement(BalanceLabel, { key: "".concat(id, "-end-title"), label: isCurrentBillingPeriod
                    ? copy('currentBalanceLabel')
                    : copy('closingBalanceLabel'), date: isCurrentBillingPeriod
                    ? (0, date_1.formatRowDate)(new Date().toDateString())
                    : (0, date_1.formatRowDate)(end) }),
            react_1.default.createElement(RowValue, { key: "".concat(id, "-end-value"), amount: closingBalance, isClosingBalance: true, creditType: "balance" }),
        ]);
    }
    var _g = (0, date_1.formatHeadingDateRange)(start, end), startDate = _g.startDate, endDate = _g.endDate;
    var billingDay = (0, date_fns_1.format)(start, 'dd');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        hideTableHeading || (react_1.default.createElement(Heading4, { as: "h2" },
            titlePrepend,
            " ", "".concat(startDate, " \u2013 ").concat(endDate))),
        react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.BILLING_PERIOD, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b.billingDay = billingDay, _b) },
            react_1.default.createElement(DataTable, null,
                react_1.default.createElement(TableBody, null, rows.map(function (row, i) { return (react_1.default.createElement(TableRow, { key: "".concat(id, "-").concat(i) }, row)); }))))));
};
exports.BillingPeriod = BillingPeriod;
